import React from 'react';
import cn from 'classnames';
import { controlPanelPositions, controlPanelSizes } from '../../constants';
import styles from './ControlPanel.module.scss';

const ControlPanel = ({
  className,
  children,
  position = controlPanelPositions.top,
  size = controlPanelSizes.medium,
}) => {
  return (
    <div className={cn(styles.root, className, styles[position], styles[size])}>
      {children}
    </div>
  );
};

export default ControlPanel;
